import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { CanActivateGuard } from '@workspace-app/canactivate.guard';
import * as fromCertification from '@workspace-app/certification';
import { HelpOverlayComponent } from '@workspace-app/shared';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    loadChildren: () => import('./home').then((m) => m.HOME_ROUTES),
    canActivate: [CanActivateGuard, MsalGuard],
  },
  {
    path: 'help',
    component: HelpOverlayComponent,
  },
  {
    path: 'public',
    loadChildren: () => import('./public/public.routes').then((m) => m.PUBLIC_ROUTES),
    // No authentication required for public routes
  },
  {
    path: 'services',
    loadChildren: () => import('./services').then((m) => m.ServicesRoutes),
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth').then((m) => m.AUTH_ROUTES),
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile').then((m) => m.PROFILE_ROUTES),
    canActivate: [CanActivateGuard, MsalGuard],
  },
  {
    path: 'inspections',
    loadChildren: () => import('./inspections/inspections.routes').then((m) => m.INSPECTIONS_ROUTES),
    canActivate: [CanActivateGuard, MsalGuard],
  },
  {
    path: 'certification/approved-systems',
    loadChildren: () => import('./certification').then((m) => m.APPROVED_SYSTEMS_ROUTES),
    canActivate: [CanActivateGuard, MsalGuard],
  },
  {
    path: 'certification/licenses',
    loadChildren: () => import('./certification').then((m) => m.LICENSES_ROUTES),
    canActivate: [CanActivateGuard, MsalGuard],
    providers: [
      provideState(fromCertification.licenseState, fromCertification.licenseReducer),
      provideEffects(fromCertification.LicenseEffects),
    ],
  },
  {
    path: 'crm',
    loadChildren: () => import('./crm').then((m) => m.CRM_ROUTES),
    canActivate: [CanActivateGuard, MsalGuard],
    providers: [],
  },
  {
    path: 'outdoor-exposure',
    loadChildren: () => import('./outdoor-exposure').then((m) => m.OUTDOOR_EXPOSURE_ROUTES),
    canActivate: [CanActivateGuard, MsalGuard],
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin').then((m) => m.ADMIN_ROUTES),
    canActivate: [CanActivateGuard, MsalGuard],
    providers: [],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      enableTracing: false,
      // Angular 22 changed the default to 'always'; keep the pre-22 param visibility
      paramsInheritanceStrategy: 'emptyOnly',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
